export const REDUCER_NAME="couponSlice"

export interface iCouponDTO {
    // discountProduct?: string;
    couponCode?: string;
    couponType?: string;
    discountValue?: number;
    country?: string;
    usageLimit?: number;
    startDate?: Date;
    endDate?: Date;
    activeStatus?: string;
    // giftItems?:string;
    minimumPurchaseAmount?:number;

}
export interface iCouponResponse {
    id: string;
    vendorId: string;
    // discountProduct: string;
    couponCode: string;
    couponType: string;
    discountValue: string;
    country: string;
    usageLimit: number;
    startDate: string;
    endDate: string;
    activeStatus: string;
    createdAt: string;
    updatedAt: string;
    productName: string;
    productImage: string;
    name: string;
  }
  

export interface iCouponState {
    isLoading: boolean;
    couponList: iCouponResponse[];
    errorMessage: string | null;
  }